module.exports = __webpack_public_path__ + "static/img/card-back.951e6a65.png";